var _rect, _rect2, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBtn({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 50,
    height: 50,
    rx: 25,
    fill: "#062021"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 50,
    height: 50,
    rx: 25,
    stroke: "white",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6331 34.3334H30.3665C32.6665 34.3334 33.5831 32.925 33.6915 31.2084L34.1248 24.325C34.2415 22.525 32.8081 21 30.9998 21C30.4915 21 30.0248 20.7084 29.7915 20.2584L29.1915 19.05C28.8081 18.2917 27.8081 17.6667 26.9581 17.6667H25.0498C24.1915 17.6667 23.1915 18.2917 22.8081 19.05L22.2081 20.2584C21.9748 20.7084 21.5081 21 20.9998 21C19.1915 21 17.7581 22.525 17.8748 24.325L18.3081 31.2084C18.4081 32.925 19.3331 34.3334 21.6331 34.3334Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.75 22.6667H27.25H24.75Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.75 22.6667H27.25",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0003 31C27.492 31 28.7087 29.7833 28.7087 28.2916C28.7087 26.8 27.492 25.5833 26.0003 25.5833C24.5087 25.5833 23.292 26.8 23.292 28.2916C23.292 29.7833 24.5087 31 26.0003 31Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBtn);
export default __webpack_public_path__ + "static/media/icon-btn.a6c0660c374b17ab069fb7cfee6486fd.svg";
export { ForwardRef as ReactComponent };